import { FC, ReactNode } from 'react';

import { UpgradePlanDialog } from 'src/components/tariff';

import { SubscriptionContext } from './subscription-context';
import { useSubscriptionData } from './use-subscription-data';

// ----------------------------------------------------------------------

export const SubscriptionProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const contextValue = useSubscriptionData();

  return (
    <SubscriptionContext.Provider value={contextValue}>
      {children}
      <UpgradePlanDialog
        open={contextValue.upgradeDialogOpen}
        reason={contextValue.upgradeReason}
        onClose={contextValue.closeUpgradeDialog}
      />
    </SubscriptionContext.Provider>
  );
};
